import React from 'react'
import FHeader from './FHeader'
import SHeader from './SHeader'
import THeader from './THeader'
function Header() {
  return (
    <><FHeader />
      <SHeader />
      <THeader />
    </>
  )
}

export default Header